import React from "react"
import Radio from "@kiwicom/orbit-components/lib/Radio"
import Stack from "@kiwicom/orbit-components/lib/Stack"
import styled from "styled-components" // eslint-disable-line no-restricted-imports

const Wrapper = styled.span`
  > label > div:last-of-type {
    flex: 0 0 auto;
  }

  margin-bottom: 8px !important;
`

type Props = {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/array-type, @typescript-eslint/no-explicit-any
  modes: Array<any> // invariant arrays,
  handleChange: (arg1: string) => void
  active: number | string | null | undefined
}

const RadioButtons = ({ modes, handleChange, active }: Props) => (
  <Stack direction="column" spacing="300" tablet={{ direction: "row", spacing: "600" }} inline wrap>
    {modes.map((mode) => (
      <Wrapper key={mode.value}>
        <Radio
          onChange={() => handleChange(mode.value)}
          checked={active === mode.value}
          value={mode.value}
          label={mode.label || mode.customLabel}
          disabled={mode.disabled}
        />
      </Wrapper>
    ))}
  </Stack>
)

export default RadioButtons
